<script>
export default {
  props: {
    imgURL: {
      type: String,
      default: '0.0_Overview.jpg',
    },
  },
}
</script>

<template>
  <div
    class="stillBg"
    :style="{
      backgroundImage: 'url(' + require('@assets/images/' + imgURL) + ')',
    }"
  ></div>
</template>

<style lang="scss">
@import '@design';

.stillBg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100vw;
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
</style>
